import { supabase } from '../lib/supabase';

export const authService = {
  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password
    });
    if (error) throw error;
    return data;
  },

  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  async getCurrentSession() {
    const { data: { session }, error } = await supabase?.auth?.getSession();
    if (error) {
      console.error('Session fetch error:', error);
      return null;
    }
    return session;
  },

  async getCurrentUser() {
    // First check if there's a session
    const session = await this.getCurrentSession();
    if (!session) {
      return null; // No session = anonymous user, not an error
    }
    return session?.user;
  },

  async getUserProfile(userId) {
    if (!userId) return null;
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();
    if (error) {
      console.error('Profile fetch error:', error);
      return null;
    }
    return data;
  },

  onAuthStateChange(callback) {
    return supabase?.auth?.onAuthStateChange(callback);
  }
};